<script setup lang="ts">
import type { IProps } from './UiSection.types'

withDefaults(defineProps<IProps>(), {
  color: 'white',
})
</script>

<template>
  <section
    :class="[
      'section',
      `section--${color}`,
    ]"
  >
    <slot />
  </section>
</template>

<style lang="scss" scoped>
.section {
  padding: 4rem 2.4rem;
  border-radius: 1.6rem;

  &--gray {
    background-color: $gray-100;
  }

  &--purple {
    background-color: $purple-50;
  }

  &--purple-500 {
    background-color: $purple-500;
  }

  &--light-blue-100 {
    background-color: $light-blue-100;
  }

   &--blue-400 {
    background-color: $blue-400;
  }

  &--psychology {
    background-color: $psychology-100;
  }

  @include atM {
    margin-right: 2rem;
    margin-left: 2rem;
    padding: 6rem 2.4rem;
  }

  @include atXL {
    padding: 12rem 2.4rem;
  }
}

:deep(.section__container) {
  @include section__container();
}

:deep(.section__row) {
  @include section__row();
}

:deep(.section__col) {
  @include section__col();
}

:deep(.section__button) {
  @include section__button();
}
</style>
